<script lang="ts">
    import Alert from "../alert/Alert.svelte";
    export let type: "error" | "notice" | "success" | "warning";
    export let message: string;
</script>

<div class="Snackbar">
    <Alert {message} {type} />
</div>

<style type="text/scss">
    .Snackbar {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        z-index: 1000;
    }
</style>
